export const EXECUTION_OPTIONS = {
	IMMEDIATE_DISPLAY: 1,
	TIME_BASED_DISPLAY: 2,
	ACTION_BASED_DISPLAY: 3
}
